const state = {
    chart: null,
    sensor: [],
    showChartData: null,
    // chartSensor
};
const getters = {
    get_chartData: state => {
        var get_chartData = {};
        get_chartData = state.chart;
        return get_chartData;
    },
    get_sensorData: state => {
        var get_sensorData = {};
        get_sensorData = state.sensor;
        return get_sensorData;
    },
    get_showChartData: state => {
        return state.showChartData;
    }
};
const actions = {
    set_chartData(context, array) {
        context.commit("SET_CHARTDATA", array);
    },
    set_sensorData(context, array) {
        context.commit("SET_SENSORDATA", array);
    },
    set_showChartData(context, obj) {
        context.commit("SET_SHOWCHARTDATA", obj);
    },
};
const mutations = {
    SET_CHARTDATA(state, array) {
        state.chart = array;
    },
    SET_SENSORDATA(state, array) {
        state.sensor['@' + array.name] = array;//避免有些名字已存在，多個字符處理
    },
    SET_SHOWCHARTDATA(state, obj) {
        state.showChartData = obj;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/sensorModal.js